module.exports = __webpack_public_path__ + "static/media/test-preview.21448487.jpeg";